import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';


import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { Link } from 'react-router-dom';

const TrackingForm = () => {
  const navigate = useNavigate();
  const [reference, setReference] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const validateReference = (ref) => {
    const referencePattern = /^ADT-\d{4}-\d{4}$/;
    return referencePattern?.test(ref);
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    setError('');

    if (!reference?.trim()) {
      setError('Veuillez entrer un numéro de référence');
      return;
    }

    if (!validateReference(reference?.trim())) {
      setError('Format invalide. Utilisez le format: ADT-YYYY-XXXX (ex: ADT-2026-0154)');
      return;
    }

    setIsLoading(true);
    setTimeout(() => {
      navigate(`/tracking/${reference?.trim()}`);
      setIsLoading(false);
    }, 500);
  };

  const handleInputChange = (e) => {
    const value = e?.target?.value?.toUpperCase();
    setReference(value);
    if (error) setError('');
  };

  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-10">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1">
              <div className="relative">
                <Icon 
                  name="Search" 
                  size={20} 
                  className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" 
                />
                <input
                  type="text"
                  placeholder="Entrez votre référence (ex : ADT-2026-0154)"
                  value={reference}
                  onChange={handleInputChange}
                  className="w-full pl-12 pr-4 py-4 text-lg border-2 border-gray-300 rounded-xl focus:border-green-600 focus:ring-2 focus:ring-green-100 outline-none transition-all"
                />
              </div>
              {error && (
                <p className="mt-2 text-sm text-red-600 flex items-center space-x-1">
                  <Icon name="AlertCircle" size={16} />
                  <span>{error}</span>
                </p>
              )}
            </div>
            <Button
              type="submit"
              size="lg"
              loading={isLoading}
              className="md:w-auto px-8 py-4 text-lg bg-green-700 hover:bg-green-800 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all"
            >
              Suivre mon envoi
            </Button>
          </div>
        </form>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            Votre référence se trouve sur votre bon de commande ou dans l'email de confirmation
          </p>
          <p className="mt-3 text-sm text-gray-500">
            Vous avez un compte ?{' '}
            <Link to="/client-login" className="text-green-700 hover:text-green-800 font-medium">
              Connectez-vous pour voir tous vos envois →
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TrackingForm;